import styled, { keyframes } from 'styled-components'


export const fadeIn = keyframes`
    from {
        opacity: 0;
        transform: translateY(40px)
    } to {
        opacity: 1;
        transform: translateY(0)
    }
`

export const fadeInWrapper = keyframes`
    from {
        opacity: 0;
    } to {
        opacity: 1;
    }
`

const fadeOut = keyframes`
  from {
    opacity: 1;
    transform: translateY(0);
  }
  to {
    opacity: 0;
    transform: translateY(4px);
  }
`;

const fadeOutWrapper = keyframes`
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
`;

export const OverlayWrapper = styled.div`
    height: 100vh;
    width: 100vw;
    z-index: 9999;
    position: fixed;
    display: flex;
    top: 0;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.3);
    animation: ${({ $fade }) =>  $fade === 'in' ? fadeInWrapper : fadeOutWrapper } 0.3s forwards; 
`
export const ContactContainer = styled.div`
    width: 500px;
    height: 550px;
    display: flex;
    flex-direction: column;
    border-radius: 10px;
    background-color: #f8fafc;
    position: relative;
    animation: ${({ $fade }) =>  $fade === 'in' ? fadeIn : fadeOut } 0.3s forwards; 

    @media (max-width: 600px) {
        width: 85vw;
        height: 85vh;
    }
`;

export const Heading = styled.div`
    width: 100%;
    height: 12%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    align-text: center;
    box-sizing: border-box;
    padding: 10px 30px 0px;
    
    @media (max-width: 400px) {
        padding: 10px 20px 0px;
    }
`;

export const HeadingTitle = styled.h1`
    padding-bottom: 10px;
    font-size: 30px;
    font-weight: 600;
    border-bottom: 3px solid #3b82f6;
    color: black;

    @media (max-width: 350px) {
        font-size: 20px;
    }
`;

export const UntoggleButton = styled.button`
    width: 2.5rem;
    height: 2.5rem;
    border-radius: 50%;
    border: none;
    box-sizing: box-border;
    color: white;
    background: #3b82f6;
    transition: transform 0.3s ease-in;

    @media (max-width: 350px) {
        width: 2.0rem;
        height: 2.0rem;
    }

    &:hover {
        transform: scale(1.1);
    }
`;

export const InputsContainer = styled.div`
    display: flex;
    flex-direction: column;
    padding: 10px 30px 0px;
    flex: 1 1 auto;

    @media (max-width: 400px) {
        padding: 10px 20px 0px;
    }
`

export const PersonInfoInputsContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
`

export const NameInput = styled.input`
  width: 100%;
  padding: 10px;
  transition: border-color 0.2s;
  border: none;
  border: ${({ $error }) => $error ? `2px solid #e74c3c` : `2px solid rgb(232, 232, 232)` };
  background-color: rgb(232, 232, 232);
  border-radius: 5px;

  &:focus {
    border-color: #3b82f6;
    outline: none;
  }
`

export const EmailInput = styled.input`
  width: 100%;
  padding: 10px;
  transition: border-color 0.2s;
  border: none;
  border: ${({ $error }) => $error ? `2px solid #e74c3c` : `2px solid rgb(232, 232, 232)` };
  background-color: rgb(232, 232, 232);
  border-radius: 5px;

  &:focus {
    border-color: #3b82f6;
    outline: none;
  }
`

export const EmailMessageContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 10px;
    gap: 10px;
    box-sizing: border-box;
    flex: 1 1 auto;
`

export const MessageInput = styled.textarea`
    padding: 10px;
    box-sizing: border-box;
    height: 100%;
    resize: none;
    border: ${({ $error }) => $error ? `2px solid #e74c3c` : `2px solid rgb(232, 232, 232)` };
    background-color: rgb(232, 232, 232);
    border-radius: 5px;

    &:focus {
        border-color: #2563eb;
        outline: none;
    }
`

export const Footer = styled.div`
    height: 12%;
    width: 100%;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
`;

export const SendMessageButton = styled.button`
    padding: 10px 20px;
    border-radius: 25px;
    font-weight: 600;
    width: 100px;
    color: white;
    background: ${ ({ $success }) => $success ? 'linear-gradient(to right, #28a745, #218838)' :
     ({ $error }) => $error ? 'linear-gradient(to right, #ff0000, #990000);' : 'linear-gradient(135deg, #3b82f6, #2563eb)' }; 
    transition: transform 0.3s ease;

    &:hover {
        transform: translateY(-5px);
        box-shadow: 0px 10px 15px rgba(59, 130, 246, 0.3);
    }

    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
        box-shadow: none;
    }
`
